<template>
  <MultipleSelect
    data-private
    data-testid="categoriesSelector"
    item-value="value"
    item-text="text"
    :cacheItems="false"
    :disabled="disabled"
    :error="error"
    :hideDetails="hideDetails"
    :label="labelText"
    :loading="isLoading"
    :options="inputCategories"
    :showSelectAll="false"
    :value="value"
    @change="handleChange"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'

import mixin from '@/mixins/mixin.vue'

import MultipleSelect from '@/components/Core/MultipleSelect.vue'

const OTHER_CATEGORY_ID = 'other'

export default {
  name: 'CategoriesSelector',

  mixins: [mixin],

  components: {
    MultipleSelect,
  },

  props: {
    hideDetails: { type: Boolean, required: false, default: true },
    siteIds: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
    disabled: Boolean,
    error: Boolean,
    isRequired: {
      type: Boolean,
      required: false,
    },
    label: String,
  },

  data() {
    return {
      searchTerm: '',
      isLoading: false,
      availableCategories: [],
    }
  },

  created() {
    this.fetchAvailableCategories()
  },

  computed: {
    ...mapGetters(['organizationId']),

    inputCategories() {
      const options = _.chain(this.availableCategories)
        .map(category => ({
          text: this.$t(`common.categories.${category}`),
          value: category,
        }))
        .orderBy('text', 'asc')
        .value()

      // The category labeled as "Other" should always appear at the end
      const otherOptionIndex = options.findIndex(
        opt => opt.value === OTHER_CATEGORY_ID
      )

      if (otherOptionIndex === -1) return options
      options.push(options.splice(otherOptionIndex, 1)[0])

      return options
    },

    labelText() {
      const label = this.label ?? this.$t('common.category_other')
      return this.isRequired ? `${label}*` : label
    },
  },

  methods: {
    ...mapActions({
      fetchCategories: 'categories/getSitesCategoriesList',
    }),

    handleChange(categories) {
      this.searchTerm = ''
      this.$emit('input', categories)
    },

    async fetchAvailableCategories() {
      try {
        this.isLoading = true
        const response = await this.fetchCategories({
          organizationId: this.organizationId,
          sitesIds: this.siteIds,
        })

        this.availableCategories = response.data
      } catch (err) {
        this.showError(err.message)
      } finally {
        this.isLoading = false
      }
    },

    handleRemove(categoryToRemove) {
      const categories = this.value.filter(
        categoryId => categoryId !== categoryToRemove.value
      )
      this.$emit('input', categories)
    },
  },
}
</script>
